import { Component, OnInit } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { AuthenticateSuccessComponent } from "../../components/authenticate-success/authenticate-success.component";
import { ActivatedRoute, Router } from "@angular/router";
import { PAGE_ROUTES } from "../../constants";
import { NgIf } from "@angular/common";

@Component({
  selector: "app-success",
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    AuthenticateSuccessComponent,
  ],
  templateUrl: "./success.component.html",
  styleUrl: "./success.component.scss"
})
export class SuccessComponent implements OnInit {
  protected workosToken = '';
  protected redirectUri = '';
  protected sessionId = '';

  constructor(
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this._route.queryParamMap.subscribe((params) => {
      const workosToken = params.get("accessToken")
      const redirectUri = params.get("redirectUri")
      const sessionId = params.get("sessionId")

      if (workosToken && redirectUri && sessionId) {
        this.workosToken = workosToken
        this.redirectUri = redirectUri
        this.sessionId = sessionId
      } else {
        this._router.navigate([PAGE_ROUTES.HOME], { queryParams: null })
      }
    });
  }
}